import userAPI from "@/api/userAPI";
import menuItems from "@/layouts/menuItems.js";

const state = {
  all: null
}

const getters = {
  getAll(state){
    return state.all
  },
}

const actions = {
  load_courses({ commit, getters }){
    return new Promise((resolve, reject) => {
      if(getters['getAll']){
        resolve(getters['getAll'])
        return
      }
      userAPI.getCourses().then(({data}) => {
        let courses = data.courses
        menuItems[3].items = Object.values(courses).map(course => {
          return { "url": "/courses/" + course.id, "name": course.name, "subName": course.id,"slug": "Courses", "icon": "BookIcon"}
        })
        commit('set_courses', courses)
        resolve(courses)
      }).catch(error => reject(error))
    })
  },

  empty_courses({ commit }) {
    commit('set_courses', null)
  }
}

const mutations = {
  set_courses(state, courses){
    state.all = courses
  },
}

export default({
  namespaced: true,
  state,
  getters,
  actions,
  mutations
});
